import { render, staticRenderFns } from "./WordListTable.vue?vue&type=template&id=a6feac6e&scoped=true&lang=html"
import script from "./WordListTable.vue?vue&type=script&lang=js"
export * from "./WordListTable.vue?vue&type=script&lang=js"
import style0 from "./WordListTable.vue?vue&type=style&index=0&id=a6feac6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6feac6e",
  null
  
)

export default component.exports